import '../../assets/index18.css';var f = Object.defineProperty, w = Object.defineProperties;
var y = Object.getOwnPropertyDescriptors;
var e = Object.getOwnPropertySymbols;
var g = Object.prototype.hasOwnProperty, p = Object.prototype.propertyIsEnumerable;
var l = (a, r, o) => r in a ? f(a, r, { enumerable: !0, configurable: !0, writable: !0, value: o }) : a[r] = o, t = (a, r) => {
  for (var o in r || (r = {}))
    g.call(r, o) && l(a, o, r[o]);
  if (e)
    for (var o of e(r))
      p.call(r, o) && l(a, o, r[o]);
  return a;
}, i = (a, r) => w(a, y(r));
var _ = (a, r) => {
  var o = {};
  for (var s in a)
    g.call(a, s) && r.indexOf(s) < 0 && (o[s] = a[s]);
  if (a != null && e)
    for (var s of e(a))
      r.indexOf(s) < 0 && p.call(a, s) && (o[s] = a[s]);
  return o;
};
import { jsx as u } from "react/jsx-runtime";
import { forwardRef as P } from "react";
import { L as h } from "../../Loader-B7q4DXVl.js";
const I = "ProgressIndicator-module__root___tP4aD", L = "ProgressIndicator-module__bar___RpgyL", v = {
  root: I,
  bar: L
}, N = P(($, d) => {
  var m = $, {
    "data-plum-id": a,
    color: r = "violet",
    style: o,
    variant: s = "circular",
    value: n = 0
  } = m, c = _(m, [
    "data-plum-id",
    "color",
    "style",
    "variant",
    "value"
  ]);
  const b = r === "white" ? "var(--mantine-color-white)" : r ? `var(--mantine-color-${r}-6)` : void 0;
  return s === "linear" ? /* @__PURE__ */ u(
    "div",
    i(t({}, c), {
      ref: d,
      role: "progressbar",
      "aria-valuenow": n,
      "data-plum-id": a,
      className: v.bar,
      "data-color": r,
      style: i(t({}, o), {
        "--progress-value": `${n}%`,
        "--progress-background": r === "white" ? "var(--mantine-color-gray-2)" : `var(--mantine-color-${r}-2)`
      })
    })
  ) : /* @__PURE__ */ u(
    h,
    t({
      ref: d,
      classNames: v,
      "data-plum-id": a,
      style: i(t({}, o), {
        "--progress-indicator-color": b
      })
    }, c)
  );
});
N.displayName = "ProgressIndicator";
export {
  N as ProgressIndicator
};
